import { VirtualCursorList } from '../../ui-kit/VirtualCursorList'
import type { WindowedCursorListRange } from '../../../hooks/useWindowedCursorList'
import { TeamItem } from '../TeamItem'
import type { TeamDescription } from '../../../types/entitys/teams'

type TeamsListProps = {
  teams: TeamDescription[]
  firstItemIndex?: number
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
  onStartReached?: () => void
  onRangeChanged?: (range: WindowedCursorListRange) => void
  emptyMessage?: string
}

export const TeamsList = ({
  teams,
  firstItemIndex,
  hasMore,
  isLoadingMore,
  onLoadMore,
  onStartReached,
  onRangeChanged,
  emptyMessage = 'Нет команд для отображения',
}: TeamsListProps) => {
  return (
    <VirtualCursorList
      items={teams}
      firstItemIndex={firstItemIndex}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={onLoadMore}
      onStartReached={onStartReached}
      onRangeChanged={onRangeChanged}
      getItemKey={(_index, team) => team.id}
      emptyMessage={emptyMessage}
      itemContent={(_index, team) => <TeamItem team={team} />}
    />
  )
}
